import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const LoginPage = Scrivito.provideObjClass("LoginPage", {
  attributes: {
    ...defaultPageAttributes,
    backgroundImage: ["reference", { only: ["Image"] }],
    backToLoginBtn: "string",
    changePassHeader: "string",
    changePassDescription: "string",
    changePassButton: "string",
    emailFieldLabel: "string",
    errorLoginStorage: "string",
    errorOccured: "string",
    errorPasswordsDiffer: "string",
    loginBackToHomepageBtn: "string",
    loginButton: "string",
    loginHeader: "string",
    loginNewAccount: "string",
    loginNewAccountLink: "link",
    loginReset: "string",
    loginResetLink: "link",
    newPassFieldLabel: "string",
    newPassRepFieldLabel: "string",
    oldPassFieldLabel: "string",
    passFieldLabel: "string",
    passRepeatFieldLabel: "string",
    setPassButton: "string",
    setPassDescription: "string",
    setPassHeader: "string",
    resetButton: "string",
    resetDescription: "string",
    resetHeader: "string",
    userLoggedIn: "string",
    ...metadataAttributes,
  },
});

export default LoginPage;
